// D-993b: ログイン画面を開いたら Face ID を自動で始める(この端末で ON の人が 1 人のとき)ための印と見張り。
//   ★キーはここ 1 か所(D-616)。どれも sessionStorage = このタブだけ・タブを閉じれば消える。
//   ★private mode 等で storage が投げても、ここで握りつぶす(自動開始が出ないだけ。PIN もボタンも使える)。

/** 明示ログアウト(ハブのログアウトボタン)の印。立っている間は自動開始しない(押した直後に入り直さないため)。
 *  ★アイドル 30 分のログアウトでは立てない: 戻ってきたら自動で Face ID が出るのが望ましい(ADR-SESSION-LOCK-BIOMETRIC)。 */
export const MANUAL_LOGOUT_KEY = 'clawops_faceid_manual_logout_v1'
/** 最後に自動開始した時刻。reload を繰り返す形(ログイン → 押し戻し → /login 再読込)で Face ID を連発しない。 */
export const AUTO_START_AT_KEY = 'clawops_faceid_auto_at_v1'
/** この間に自動開始していたら、もう一度は自動で始めない。 */
export const AUTO_START_COOLDOWN_MS = 60_000

export function markManualLogout() {
  try { sessionStorage.setItem(MANUAL_LOGOUT_KEY, '1') } catch { /* 印が残らないだけ */ }
}

export function wasManualLogout() {
  try { return sessionStorage.getItem(MANUAL_LOGOUT_KEY) === '1' } catch { return false }
}

export function clearManualLogout() {
  try { sessionStorage.removeItem(MANUAL_LOGOUT_KEY) } catch { /* 無視 */ }
}

// ★ページの読み込み 1 回につき 1 回だけ(モジュールの変数 = StrictMode の二重 mount でも、
//   SPA 内で /login に戻ってきた再 mount でも 2 回目は無い)。iOS Safari が操作なしで許す
//   credentials.get() はページごとに 1 回なので、それを使い切った後に自動で呼んでも通らない。
let claimed = false

/**
 * 自動開始してよいかを判定し、よければ「使った」と記録する(1 回だけ true)。
 * @returns {boolean}
 */
export function claimFaceIdAutoStart(now = Date.now()) {
  if (claimed) return false
  claimed = true
  if (wasManualLogout()) return false
  try {
    const last = Number(sessionStorage.getItem(AUTO_START_AT_KEY))
    if (Number.isFinite(last) && last > 0 && now - last >= 0 && now - last < AUTO_START_COOLDOWN_MS) return false
    sessionStorage.setItem(AUTO_START_AT_KEY, String(now))
  } catch { /* 記録できなくても、このページ内の 1 回は claimed が守る */ }
  return true
}

/** テスト専用: ページ読み込みの見張りを戻す。 */
export function __resetFaceIdAutoStartForTests() {
  claimed = false
}
